var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2964 4.47576C9.6716 3.74576 8.7376 3.32976 7.7624 3.40776C6.508 3.50816 5.6112 3.64456 4.9884 3.77136C3.994 3.97336 3.334 4.77737 3.2324 5.75177C3.1208 6.81977 3 8.71697 3 11.9286C3 15.1402 3.1208 17.0374 3.232 18.1054C3.334 19.0794 3.9932 19.8834 4.9876 20.0854C6.16 20.3242 8.3104 20.5986 12 20.5986C15.6896 20.5986 17.8396 20.3242 19.0124 20.0854C20.0068 19.8834 20.666 19.0794 20.7676 18.1054C20.8792 17.0374 21 15.1402 21 11.9286C21 10.6698 20.9816 9.61337 20.952 8.72976C20.8972 7.07056 19.5296 5.80696 17.9052 5.80696H11.928C11.7731 5.80668 11.62 5.77281 11.4794 5.7077C11.3388 5.64258 11.214 5.54776 11.1136 5.42976L10.2964 4.47576Z",
    fill: "#8FBFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.fbb98adcde696fc69f12e8fd2bc675bf.svg";
export { ForwardRef as ReactComponent };